var _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavbarHospitalOn = function SvgNavbarHospitalOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "navbar-hospital-on_svg__a",
    width: 18,
    height: 22,
    x: 3,
    y: 1,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M3 1.5h18v21H3z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#navbar-hospital-on_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF540F",
    fillRule: "evenodd",
    d: "M15 10.531h-2.25v2.25h-1.5v-2.25H9v-1.5h2.25v-2.25h1.5v2.25H15zM12 1.5c-4.963 0-9 3.811-9 8.495 0 7.304 8.228 12.049 8.578 12.247l.456.258.435-.288c.348-.23 8.53-5.712 8.53-12.217C21 5.311 16.964 1.5 12 1.5",
    clipRule: "evenodd"
  }))));
};
export default SvgNavbarHospitalOn;